import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MathwayColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M0 22v17.436c0 1.21.477 2.371 1.325 3.227A4.502 4.502 0 0 0 4.523 44h34.954c1.2 0 2.35-.48 3.198-1.337A4.585 4.585 0 0 0 44 39.436V22H0Z",
    svgColor: "#B8313A"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M44 22V4.564c0-1.21-.477-2.371-1.325-3.227A4.503 4.503 0 0 0 39.477 0H4.523c-1.2 0-2.35.48-3.198 1.337A4.586 4.586 0 0 0 0 4.564V22h44Z",
    svgColor: "#D88E8C"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m28.343 5-6.338 11.476L15.657 5H5v17h6.607V8.63L18.437 22h7.126l6.839-13.37V22H39V5H28.343Z",
    svgColor: "#fff"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m28.343 39-6.338-11.467L15.657 39H5V22h6.607v13.37L18.437 22h7.126l6.839 13.37V22H39v17H28.343Z",
    svgColor: "#E0A5A5"
  }));
});
MathwayColor.displayName = 'MathwayColor';
MathwayColor.defaultProps = {
  'aria-label': 'MathwayColor'
};
export default MathwayColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/MathwayColor.js
// module id = 3583
// module chunks = 11